import "./form-invoice.scss";

import { InvoiceFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = InvoiceFormSchema;
export function FormInvoice() {
  const { control } = useFormContext<InvoiceFormSchema>();
  return (
    <div id="FormInvoice" className="invoice">
      <InputControl<InputFormSchema>
        control={control}
        name="invoiceDate"
        label="Invoice Date"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter invoiceDate"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="amount"
        label="Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter amount"
      />
    </div>
  );
}

export default FormInvoice;
